// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"688":"WxLaunchHack","962":"QQShare"}[chunkId] || chunkId) + "." + {"388":"0ea367f963","688":"dbbb478439","962":"236e7a3994"}[chunkId] + ".js";
};